<template>
  <van-dialog
    theme="round-button"
    class="custom-dialog"
    v-model="show"
    :title="data.title"
    :show-confirm-button="data.showConfirmButton"
    :show-cancel-button="data.showCancelButton"
    :confirm-button-text="data.confirmButtonText"
    :cancel-button-text="data.cancelButtonText"
    @confirm="confirm"
    @cancel="cancel"
  >
    <div class="dialog-content">
      <div
        class="height-100"
        v-if="data.confirmText"
      >{{ data.confirmText }}</div>
      <div v-else-if="data.confirmObj">
        <van-row
          v-for="(item,index) in data.confirmObj"
          :key="index"
        >
          <van-col
            span="12"
            :class="{ 'space' : item.space }"
          >{{ item.key }}</van-col>
          <van-col
            span="12"
            :class="{ 'space' : item.space }"
          >{{ item.value }}</van-col>
        </van-row>
      </div>

      <div
        class="content-text"
        v-if="data.confirmText2"
      >
        <span
          v-for="(item, index) in data.confirmText2"
          :key="index"
          :class="[`color-${item.color}`]"
        >{{ item.text }}</span>
      </div>
    </div>
  </van-dialog>
</template>

<script>
const initData = () => {
  return {
    title: '提示',
    showCancelButton: true,
    showConfirmButton: true,
    cancelButtonText: '取消',
    confirmButtonText: '确认',
    confirmText: null,
    confirmObj: null
  };
};
export default {
  name: 'ConfirmDialog',
  data() {
    return {
      show: false,
      data: initData()
    };
  },
  methods: {
    open(data) {
      this.data = initData();
      data && (this.data = { ...this.data, ...data });
      this.show = true;
    },
    close() {
      this.show = false;
    },
    confirm() {
      this.close();
      this.data.confirmCallback && this.data.confirmCallback.apply(this);
    },
    cancel() {
      this.close();
      this.data.cancelCallback && this.data.cancelCallback.apply(this);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-dialog{
  &.van-dialog ::v-deep {
    .van-dialog__header{
      padding: 14px 0;

      text-align: center;

      color: #383838;
      border-radius: 8px 8px 0px 0px;
      background: #FFFFFF;
      box-shadow: inset 0px -1px 0px 0px rgba(230,230,230,1);

      font-family: PingFangSC-Regular;
      font-size: 16px;
      font-weight: 400;
    }
    .van-dialog__content{
      .dialog-content{
        padding: 8px 16px 24px;

        text-align: center;
        letter-spacing: -0.41px;

        color: #646464;

        font-family: PingFangSC-Regular;
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .height-100{
          padding-top: 16px;
          overflow-y: auto;

          max-height: 100px;
        }

        .content-text{
          padding: 16px 4px 0;
          overflow-y: auto;

          max-height: 120px;
          .color-red{
            color: #F32222;
          }
        }

        .van-row{
          .van-row{
            padding-top: 16px;
          }
          .van-col{
            text-align: left;
            & + .van-col{
              text-align: right;

              color: #383838;

              font-family: PingFangSC-Medium;
              font-weight: 500;
            }
          }
        }
      }
    }
    .space {
        margin-top: 16px;
    }
    .van-dialog__footer {
      padding: 0 16px 24px;
      .van-button {
        height: 40px;

        text-align: center;
        letter-spacing: -0.41px;

        & + .van-button {
          margin-left: 17px;
        }
        &.van-dialog__cancel {
          color: #646464;
          border-radius: 8px;
          background: #EDF2F7;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
        &.van-dialog__confirm {
          color: #ffffff;
          border-radius: 8px;
          background: #3399FF;

          font-family: PingFangSC-Regular;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
}
</style>
